/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

// this component to display the dashboard card
const DashboardCard = ({
  title,
  value,
  icon: Icon,
  color,
  minHeight,
  component,
}) => {
  return (
    <Card
      sx={{
        minWidth: 200,
        minHeight: minHeight ?? "100px",
        backgroundColor: "white",
        color: color ?? "white",
        borderRadius: "1rem",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        border: "1px solid #e0e0e0",
        transition: "0.3s",
        "&:hover": {
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.12)", // Deeper shadow on hover
        },
      }}
    >
      <CardContent sx={{padding:"0.5rem",paddingBottom:"0.5rem !important"}}>
        {component || (
          <>
            <Typography variant="h6" component="div" color="#666666">
              {title}
            </Typography>

            <Box display="flex" alignItems="end" justifyContent="space-between">
              {Icon && <Icon fontSize="3rem" />}

              <Box>
                <Typography variant="h4" component="div" sx={{ mt: 2 }}>
                  {value}
                </Typography>
              </Box>
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default DashboardCard;
